import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';

var useDndPlaceholder = function useDndPlaceholder() {
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    props = _React$useState2[0],
    setProps = _React$useState2[1];
  var clearProps = function clearProps() {
    setProps(null);
  };
  var calculateProps = React.useCallback(function (draggableId, source, target) {
    var _target, _target2;
    var draggedDOM = getDraggableDom(draggableId);
    var droppableDOM = getDroppableDom(((_target = target) !== null && _target !== void 0 ? _target : source).droppableId);
    if (!draggedDOM || !droppableDOM) {
      return;
    }
    var clientHeight = draggedDOM.clientHeight,
      clientWidth = draggedDOM.clientWidth;
    target = (_target2 = target) !== null && _target2 !== void 0 ? _target2 : source;
    var placeholderDom = document.getElementById("_mntl-placeholder-".concat(target.droppableId));
    if (!placeholderDom) return;
    var targetIndexForPositioning = target.index;
    var targetChildrenDomList = getDroppableChildrenDom(target.droppableId);
    var targetParentDom = targetChildrenDomList.length ? targetChildrenDomList[0].parentElement : droppableDOM;
    if (targetChildrenDomList.length && targetParentDom.contains(placeholderDom)) {
      targetParentDom.removeChild(placeholderDom);
    }
    if (source.droppableId === target.droppableId && source.index < targetIndexForPositioning) {
      targetParentDom.insertBefore(placeholderDom, targetParentDom.children[targetIndexForPositioning + 1]);
    } else {
      targetParentDom.insertBefore(placeholderDom, targetParentDom.children[targetIndexForPositioning]);
    }
    setProps({
      sourceDroppableId: source.droppableId,
      targetDroppableId: target ? target.droppableId : void 0,
      clientHeight: clientHeight,
      clientWidth: clientWidth
    });
  }, []);
  return {
    props: props,
    calculateProps: calculateProps,
    clearProps: clearProps
  };
};
function getDraggableDom(draggableId) {
  var domQuery = "[data-rbd-draggable-id='".concat(draggableId, "']");
  return document.querySelector(domQuery);
}
function getDroppableDom(droppableId) {
  var domQuery = "[data-rbd-droppable-id=\"".concat(droppableId, "\"]");
  return document.querySelector(domQuery);
}
function getDroppableChildrenDom(droppableId) {
  var domQuery = "[data-rbd-droppable-id=\"".concat(droppableId, "\"] [data-rbd-draggable-id]");
  return document.querySelectorAll(domQuery);
}

export { useDndPlaceholder };
